import { technicalResponsibles } from "@/mocks/partes";
import PartyStatusBadge from "./PartyStatusBadge";

export default function TechnicalResponsiblePanel() {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-900">Responsáveis Técnicos ({technicalResponsibles.length})</h3>
        <button className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap">
          <i className="ri-add-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
          Novo responsável
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {technicalResponsibles.map((tech) => (
          <div key={tech.id} className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-background-300 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 font-heading">{tech.name}</h4>
                <p className="text-xs text-foreground-400">{tech.institution !== "—" ? tech.institution : ""}</p>
              </div>
              <PartyStatusBadge status={tech.status} />
            </div>

            <div className="grid grid-cols-2 gap-3 mb-3">
              <div className="bg-background-50 rounded-lg p-2.5">
                <p className="text-xs text-foreground-400">{tech.council}</p>
                <p className="text-sm font-semibold text-foreground-800">{tech.registrationNumber}</p>
              </div>
              <div className="bg-background-50 rounded-lg p-2.5">
                <p className="text-xs text-foreground-400">Especialidade</p>
                <p className="text-sm font-semibold text-foreground-800">{tech.specialty}</p>
              </div>
            </div>

            <div className="flex items-center gap-4 text-xs text-foreground-500 mb-3">
              <span className="flex items-center gap-1">
                <i className="ri-briefcase-line w-3.5 h-3.5 flex items-center justify-center text-primary-500" />
                <strong className="text-primary-600">{tech.activeLinks}</strong> projetos
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-file-text-line w-3.5 h-3.5 flex items-center justify-center text-accent-500" />
                {tech.hasDocuments ? "Docs anexados" : "Sem docs"}
              </span>
            </div>

            <div className="flex gap-2">
              <button className="flex-1 px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors text-center whitespace-nowrap">
                <i className="ri-eye-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Ver detalhes
              </button>
              <button className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap">
                <i className="ri-file-list-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Documentos
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}